import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import PagingToolbar from '@molecules/PagingToolbar';
import { mediaQueries } from '@general/breakpoints';

const PagingContainerOuter = styled.div`
    @media ${mediaQueries.md} {
        padding-top: 24px;
    }
`;

const PagingContainerInner = styled.div`
    @media ${mediaQueries.md} {
        padding-top: 32px;
        padding-bottom: 48px;
    }
`;

// Uses render props so the children have access to the records
const PagedRecords = ({ records, recordsPerPage, children }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [currentRecords, setCurrentRecords] = useState(records.slice(0, recordsPerPage));

    useEffect(() => {
        const pageStart = (currentPage - 1) * recordsPerPage;
        setCurrentRecords(records.slice(pageStart, pageStart + recordsPerPage));
    }, [currentPage, records, recordsPerPage]);

    return (
        <div className="paged-records">
            {children(currentRecords)}

            {records.length > recordsPerPage && (
                <PagingContainerOuter>
                    <PagingContainerInner>
                        <PagingToolbar
                            currentPage={currentPage}
                            totalPages={Math.ceil(records.length / recordsPerPage)}
                            onPageChange={setCurrentPage}
                        />
                    </PagingContainerInner>
                </PagingContainerOuter>
            )}
        </div>
    );
};

PagedRecords.propTypes = {
    records: PropTypes.array.isRequired,
    recordsPerPage: PropTypes.number.isRequired,
    // children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
    children: PropTypes.any,
};

export default PagedRecords;
